import { TFunction } from 'i18next';
import { KPITypes } from 'models/kpi/kpi';
import KPIData from 'models/kpi/kpiData';
import KPIDataContext from 'models/kpi/kpiDataContext';
import Task from 'models/tasks/task';
import { Integration } from './integration';
import { IntegrationRun } from './integrationRun';

export enum IntegrationExecutionMode {
  Normal = 0,
  Test = 1,
  TestAuth = 2,
}

export class IntegrationResult {
  integration: Integration | undefined;

  mode: IntegrationExecutionMode | undefined;

  run: IntegrationRun | undefined;

  data: KPIData | undefined;

  context: KPIDataContext[];

  taskForNotAcceptedResult: Task | undefined;

  evidence: string | undefined;

  constructor() {
    this.context = [];
  }

  getRunOutcome = (): boolean | undefined => {
    if (this.run?.error) return false; //run failed probably due to technical reasons
    if (!this.data) return undefined; //should not happen but run maybe in progress?

    return this.data.getRunOutcome();
  };

  getRunOutcomeText = (t: TFunction<string[]>): string | undefined => {
    let outcomeText: string = '';

    if (this.run?.error) {
      outcomeText = t('integrations:Dialogs.Test.RunOutcomeError');
    } else {
      if (!this.data || !this.data.kpi) return undefined;

      if (this.data.kpi.type !== KPITypes.SuccesError) {
        outcomeText = t('integrations:Dialogs.Test.RunOutcomeOk');
      } else {
        if (this.data.resultNumber === 1) {
          outcomeText = t('integrations:Dialogs.Test.RunOutcomeAccepted');
        } else {
          outcomeText = t('integrations:Dialogs.Test.RunOutcomeRejected');
        }
      }
    }

    return outcomeText;
  };

  getRunOutcomeInfo = (integrationName: string, t: TFunction<string[]>): string | undefined => {
    if (!this.data || !this.data.kpi) return undefined;

    if (this.data.kpi.type !== KPITypes.SuccesError) {
      return t('integrations:Dialogs.Test.RunOutcomeInfoNumeric', { name: integrationName });
    } else {
      return t('integrations:Dialogs.Test.RunOutcomeInfoSuccessError', { name: integrationName });
    }
  };
}
